<template>
  <modal title="" width="45" :showModal="showModal" @close-modal="closeModal">
    <div class="flex flex-col" v-loading="loading">
      <div>
       <div class="flex justify-center">
        <span> 
          <svg width="179" height="144" viewBox="0 0 179 144" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M135.19 85.6128C122.748 85.6128 112.627 93.7553 112.627 103.764C112.627 113.773 122.748 121.915 135.19 121.915C147.634 121.915 157.753 113.773 157.753 103.764C157.753 93.7553 147.632 85.6128 135.19 85.6128ZM135.19 112.84C128.968 112.84 123.909 108.769 123.909 103.764C123.909 98.759 128.968 94.6884 135.19 94.6884C141.412 94.6884 146.472 98.759 146.472 103.764C146.472 108.77 141.412 112.84 135.19 112.84Z" fill="#09B78A"/>
            <path d="M58.0992 85.6128C45.6577 85.6128 35.5361 93.7553 35.5361 103.764C35.5361 113.773 45.6577 121.915 58.0992 121.915C70.5408 121.915 80.6623 113.773 80.6623 103.764C80.6623 93.7553 70.5408 85.6128 58.0992 85.6128ZM58.0992 112.84C51.8776 112.84 46.8177 108.769 46.8177 103.764C46.8177 98.759 51.8776 94.6884 58.0992 94.6884C64.3191 94.6884 69.3808 98.759 69.3808 103.764C69.3808 108.77 64.3209 112.84 58.0992 112.84Z" fill="#09B78A"/>
            <path d="M150.385 33.659C149.426 32.1268 147.476 31.1601 145.344 31.1601H115.636V40.2358H141.865L157.225 64.8125L167.307 60.7344L150.385 33.659Z" fill="#09B78A"/>
            <path d="M118.268 99.3785H75.5859V108.454H118.268V99.3785Z" fill="#09B78A"/>
            <path d="M41.1774 99.3785H21.623C18.5073 99.3785 15.9824 101.41 15.9824 103.916C15.9824 106.423 18.5076 108.454 21.623 108.454H41.1777C44.2934 108.454 46.8183 106.422 46.8183 103.916C46.8183 101.41 44.2931 99.3785 41.1774 99.3785Z" fill="#09B78A"/>
            <path d="M177.816 71.6373L166.72 60.1415C165.654 59.0342 164.009 58.3867 162.266 58.3867H121.276V26.6221C121.276 24.1156 118.751 22.0844 115.636 22.0844H21.623C18.5073 22.0844 15.9824 24.1159 15.9824 26.6221C15.9824 29.1283 18.5076 31.1598 21.623 31.1598H109.995V62.9244C109.995 65.4309 112.52 67.4621 115.635 67.4621H159.504L167.718 75.975V99.3781H152.112C148.997 99.3781 146.472 101.41 146.472 103.916C146.472 106.422 148.997 108.453 152.112 108.453H173.359C176.475 108.453 179 106.422 179 103.916V74.4205C179 73.4131 178.583 72.4329 177.816 71.6373Z" fill="#09B78A"/>
            <path d="M40.8021 76.3872H14.8545C11.7387 76.3872 9.21387 78.4187 9.21387 80.9249C9.21387 83.4314 11.7391 85.4626 14.8545 85.4626H40.8018C43.9175 85.4626 46.4424 83.4311 46.4424 80.9249C46.4427 78.4187 43.9175 76.3872 40.8021 76.3872Z" fill="#09B78A"/>
            <path d="M53.7752 58.5382H5.6406C2.52523 58.5382 0 60.5697 0 63.0762C0 65.5827 2.52523 67.6139 5.6406 67.6139H53.7752C56.8909 67.6139 59.4158 65.5824 59.4158 63.0762C59.4158 60.57 56.8909 58.5382 53.7752 58.5382Z" fill="#09B78A"/>
            <path d="M62.989 40.6885H14.8545C11.7387 40.6885 9.21387 42.7199 9.21387 45.2262C9.21387 47.7327 11.7391 49.7639 14.8545 49.7639H62.989C66.1047 49.7639 68.6296 47.7324 68.6296 45.2262C68.63 42.7199 66.1047 40.6885 62.989 40.6885Z" fill="#09B78A"/>
          </svg>
        </span>
       </div>
        <p> This shipment has successfully been dispatched. You still have 5/27 items left to process. Click to process another transload. </p>
      </div>

      <div class="flex items-center justify-between mt-10">
        <div class="cursor-pointer" @click="$router.go(-1)">
          <p>Exit & Process later</p>
        </div>
        <base-button
          text="Process Transload"
          @click="$emit('finish')"
        />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      
      loading: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>

<style scoped>
.button {
  background: #fcc210;
  color: var(--primaryblue);
  width: 40%;
  font-weight: 500;
  /* margin-top: 3rem; */
}
.new-address-button {
  text-decoration-line: underline;

  color: #da9601;
}

.radio-label span::after {
  background: #bec4d5;
}
</style>
